// NOTE: Bu metin bir taslaktır. Hukuki kontrol önerilir.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Gizlilik Politikası"
      subtitle="Kişisel verilerinizi nasıl işlediğimizi, neden işlediğimizi ve sizin haklarınızı şeffaf biçimde açıklıyoruz."
      lastUpdated="Mayıs 2026"
      version={LEGAL_VERSIONS.privacy}
      testid="privacy-page"
    >
      <h2>1. İşlenen Veri Kategorileri</h2>

      <h3>Hesap bilgileri</h3>
      <p>Ad-soyad, e-posta adresi, şifre (yalnızca güvenli özet/hash olarak saklanır), kayıt ve son giriş tarihleri.</p>

      <h3>İşletme bilgileri</h3>
      <p>İşletme adı, sektör, lokasyon (il/ilçe), hedef müşteri tipi, rakip işletme isimleri ve sağlanan web sitesi adresi.</p>

      <h3>Web sitesi analiz verileri</h3>
      <p>
        Sağladığınız web sitesinin <strong>kamuya açık</strong> içeriği (başlıklar, metin,
        sayfa yapısı, meta etiketler, robots.txt ve schema.org sinyalleri) analiz amacıyla
        getirilir ve sonuç skorları çıkarmak için işlenir.
      </p>

      <h3>Kullanım verileri</h3>
      <p>
        Hangi özellikleri kullandığınız, içerik üretim adetleri, yeniden tarama sayıları,
        AI soru testi adetleri ve aylık kota durumunuz hizmet limitlerini yönetmek için
        tutulur.
      </p>

      <h3>Pazarlama izni</h3>
      <p>
        Pazarlama e-postası almak isteyip istemediğiniz ve bu tercihi verdiğiniz an
        kayıt altına alınır. Bu tercihi istediğiniz an geri alabilirsiniz.
      </p>

      <h2>2. İşleme Amaçları</h2>
      <ul>
        <li>Hesabınızı oluşturmak, sürdürmek ve hizmeti sağlamak</li>
        <li>AI görünürlük skorunuzu ve önerileri üretmek</li>
        <li>Plan limitlerini ve faturalandırmayı yönetmek</li>
        <li>Güvenlik, sahteciliği önleme ve hukuki yükümlülükler</li>
        <li>İzin verdiyseniz ürün ve kampanya iletişimi</li>
      </ul>

      <h2>3. Veri Güvenliği</h2>
      <p>
        Şifreleri yalnızca tek yönlü <strong>bcrypt</strong> ile saklarız. Şifre sıfırlama
        token'ları yalnızca SHA-256 özet hâliyle veritabanında tutulur. Tüm trafik HTTPS
        üzerinden taşınır.
      </p>

      <h2>4. Saklama Süresi</h2>
      <p>
        Hesabınızı sildiğinizde kişisel verileriniz makul süre içinde silinir veya
        anonim hâle getirilir. Mevzuat gereği saklanması gereken muhasebe/iletişim
        kayıtları, ilgili yasal süre boyunca tutulur.
      </p>

      <h2>5. Veri Aktarımı</h2>
      <p>
        Hizmetin sağlanması için sınırlı veriler, yapay zekâ analizi için OpenAI/Anthropic
        gibi üçüncü taraf sağlayıcılarla, ödeme entegrasyonu devreye alındığında ise
        ödeme servisi sağlayıcısı ile paylaşılabilir. Bu aktarımlar yalnızca işlerin
        yapılabilmesi için gerekli olan asgari veriyi kapsar.
      </p>

      <h2>6. Çerezler</h2>
      <p>
        Çerezlerin nasıl kullanıldığı için lütfen <a href="/cerez-politikasi">Çerez Politikası</a>
        sayfasını inceleyin.
      </p>

      <h2>7. Kullanıcı Hakları</h2>
      <p>KVKK kapsamında sahip olduğunuz haklara ilişkin detaylar için lütfen{" "}
        <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</a>'ni inceleyin.</p>

      <h2>8. İletişim</h2>
      <p>Veri işleme süreçlerimizle ilgili her türlü soru için <a href="/iletisim">iletişim sayfası</a> üzerinden bize ulaşabilirsiniz.</p>
    </LegalPage>
  );
}
